import { z } from "zod";

export const ReajusteContratoIndividualSchema = z.object({
    idContratoFinanceiro: z.number().optional().nullable(),
    idIndiceReajuste: z.number().optional().nullable(),
    aplicarNaEntrada: z.coerce.number().default(0),
    dataInicioAplicacaoReajuste: z.coerce.date().optional().nullable(),
    dataReajusteDe: z.coerce.date().optional().nullable(),
    dataReajusteAte: z.coerce.date().optional().nullable(),

});

export type ReajusteContratoIndividualForm = z.infer<typeof ReajusteContratoIndividualSchema>;

export const defaultReajusteContratoIndividualForm: Partial<ReajusteContratoIndividualForm> = {
    aplicarNaEntrada: 0,

}